import { useGlobalConfig } from '@dealstack/frontend/shared/globalConfig';
import { useQuery } from '@tanstack/react-query';
import { JurisdictionType } from '@dealstack/shared/lib/generated';

export interface Jurisdiction {
	jurisdiction_name: string;
	country_code: string;
	type: JurisdictionType;
	group: string;
	languages: string[];
}

export function useJurisdictions() {
	const { assetsUrl } = useGlobalConfig();

	const jurisdictions = useQuery({
		queryKey: ['jurisdictions'],
		queryFn: async (): Promise<Jurisdiction[]> => {
			return fetch(`${assetsUrl}/context/countries/jurisdictionData.json`).then((res) =>
				res.json()
			);
		},
	});

	return jurisdictions.data ?? [];
}
